import * as types from '../../action-types';
import { getApplicantMatric as initialState } from "../../initialState";

const getApplicantMatric = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_APPLICANT_MATRIC_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_APPLICANT_MATRIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_APPLICANT_MATRIC_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_APPLICANT_MATRIC_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getApplicantMatric;
